<style lang="scss">
</style>

<template>
    <div class="lookinfo">
        <Alert class="padding-15" show-icon>操作提示：带有”<span class="color-danger">*</span>“的选项为必填项，其他为选填项。</Alert>
        <div class="bg-fff shadow padding-15 ">
            <vForm :label-width="160" ref="form" :model="formData" class="clearfix">
                <vCol span="12">
                <vFormItem prop="tranNo" label='Amazon移库计划单号:' :rules='required'>
                    <span>{{formData.tranNo}}</span>
                </vFormItem>
                </vCol>
                <vCol span="12">
                <vFormItem label='项目:' prop="lineId" :rules='required'>
                    <Select v-model="formData.lineId" filterable>
                        <!-- <Option :value="-1" key="-1">Others</Option> -->
                        <Option v-for="item in newproducts" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </vFormItem>
                </vCol>
                <vCol span="24">
                </vCol>
                <vCol span="12">
                <vFormItem prop="orgwarehouseId" label='调出仓库:' :rules='required'>
                   <Select
                    clearable 
                    v-model="formData.orgwarehouseId"
                    filterable      >
                       <Option v-for="item in amazonWarehouses" :value="item.id" :key="item.id">{{ item.title }}({{ item.code }})</Option>
                    </Select>
                </vFormItem>
                 </vCol>
                <vCol span="12">
                <vFormItem prop="srcOrgwarehouseId" label='接收仓库:' :rules='required' >
                    <Select
                    clearable 
                    v-model="formData.srcOrgwarehouseId"
                    filterable
                    @on-change="getAllotAddress">
                       <Option v-for="item in newwarehouses" :value="item.id" :key="item.id">{{ item.title }}({{ item.code }})</Option>
                    </Select>
                </vFormItem>
                </vCol>
                <vCol span="12">
                <vFormItem prop="isLabel" label='是否更换产品标:' :rules='required'>
                    <RadioGroup v-model="formData.isLabel">
                        <Radio :label="1">是</Radio>
                        <Radio :label="0">否</Radio>
                    </RadioGroup>
                </vFormItem>
                 </vCol>
                <vCol span="12">
                <vFormItem prop="inventoryType" label='库存类型:' :rules='required'>
                    <RadioGroup v-model="formData.inventoryType">
                    <Radio :label="1">不可售库存</Radio>
                    <Radio :label="0">可售库存</Radio>
                </RadioGroup>
                </vFormItem>
                 </vCol>
                 <vCol span="12">
					<vFormItem label="期望入库日期" prop="estimateInboundAt" :rules='getIsRequired'>
                        <DatePicker v-model="formData.estimateInboundAt" class="width-100per" type="date"></DatePicker>
					</vFormItem>
				</vCol>
                 <vCol span="12">
                <vFormItem prop="removeOrderId" label='Remove Order ID:' :rules='required'>
                    <Input v-model="formData.removeOrderId"/>
                </vFormItem>
                 </vCol>
                <vCol span="12" :rules='required'>
                <vFormItem prop="orderDate" label='创建日期'  :rules='required'>
                    <DatePicker v-model="formData.orderDate" type="date" class="width-100per"></DatePicker>
                </vFormItem>
                </vCol>
            </vForm>
            <vForm :label-width="160" ref="other" :model="address" class="clearfix">
                 <vCol span="12">
                <vFormItem prop="country" label='目的国家:' :rules='required'>
                    <Input v-model="address.country" :disabled='disabled'/>
                </vFormItem>
                 </vCol>
                <vCol span="12">
                <vFormItem prop="state" label='州:' :rules='required'>
                    <Input v-model="address.state" :disabled='disabled'/>
                </vFormItem>
                 </vCol>
                <vCol span="12">
                 <vFormItem prop="city" label='城市:' :rules='required'>
                    <Input v-model="address.city" :disabled='disabled'/>
                </vFormItem>
                 </vCol>
                <vCol span="12">
                <vFormItem prop="postal" label='邮编:' :rules='required'>
                    <Input v-model="address.postal" :disabled='disabled'/>
                </vFormItem>
                 </vCol>
                <vCol span="12">
                <vFormItem prop="linkman" label='联系人:' :rules='required'>
                    <Input v-model="address.linkman" :disabled='disabled'/>
                </vFormItem>
                 </vCol>
                  <vCol span="12">
                <vFormItem prop="mobilePhone" label='电话:' :rules='required'>
                    <Input v-model="address.mobilePhone"  :disabled='disabled'/>
                </vFormItem>
                 </vCol>
                <vCol span="12">
                 <vFormItem label='移动电话:'>
                    <Input v-model="address.phone"  :disabled='disabled'/>
                </vFormItem>
                 </vCol>
                <vCol span="12">
                <vFormItem label='联系地址:' prop="address" :rules='required'>
                    <Input v-model="address.address" :disabled='disabled'/>
                </vFormItem>
                 </vCol>
                <vCol span="12">
                <vFormItem label='联系地址2:'>
                    <Input v-model="address.address2" :rows="4"  :disabled='disabled'/>
                </vFormItem>
                 </vCol>
                <vCol span="12">
                <vFormItem label='描述:'>
                    <Input v-model="formData.remark" :rows="4" type="textarea" />
                </vFormItem>
                 </vCol>
            </vForm>
        </div>
    </div>
</template>

<script>
import { mapState,mapGetters} from 'vuex'
import { HttpAllotNo } from '@/service/allotment/transfer';
import { HttpAllotAddress } from '@/service/boss/dictionary'


export default {
    props: ['data', 'type'],
    watch: {
        data: {
            deep: true,
            handler(val) {
                this.formData = { ...this.formData, ...val, lineId: parseInt(val.lineId) };
                this.address = {...val.extraData};
            }
        },
        'formData.srcOrgwarehouseId': function (val) {
            this.formData.srcOrgwarehouseId=val;
            if (val == -1) {
                this.disabled = false;
            } else {
                this.disabled = true;
            }
        }
    },
    created() {
        if (this.type === 'add') this.getAllotNo();
    },
    data() {
        return {
            disabled: false,
            showInTime:true,
            address: {
                remark: "",
                country: "",
                state: "",
                city: "",
                postal: "",
                address: "",
                address2: "",
                linkman: "",
                phone: "",
                mobilePhone: "",
            },
            formData: {
                lineId: "",
                orgwarehouseId: "",
                srcOrgwarehouseId: "",
                tranNo: "",
                orderStatus: "",
                removeOrderId: "",
                isLabel: 0,
                inventoryType: 0,
            },
            required: [{
                required: true,
                message: "该信息不能为空,请填写"
            }],
        }
    },


    computed: {
        ...mapState('boss',['products']),
        ...mapGetters('boss', ['warehouses', 'amazonWarehouses']),
        ...mapGetters('diction',['getNewWarehouseIdList']),
        newproducts() {
            return [{ id: -1, name: "Others" },...this.products]
        },
        newwarehouses() {
            return [{ id: -1, title: "Others",code:'-' },...this.warehouses]
        },
        getIsRequired () {
            if (this.showInTime) {
                return this.required;
            }
            else {
                return [{
                    required: false
                }];
            }
        }
    },
    methods: {
        async getAllotNo() {
            HttpAllotNo().then(res => {
                this.formData.tranNo = res.data;
            });
        },
        async getAllotAddress(val) {
            if (!val || val == -1){
                this.showInTime = false;
                console.log(this.showInTime)
                return this.extraData = {};
            } else{
                this.showInTime = true;
                console.log(this.showInTime)
                HttpAllotAddress({ warehouseId: val }).then(res => {
                    // let { country, state, city, address, address2, linkman, phone, mobilePhone, postal } = res.data;
                    this.address = res.data;
                });
            }
          /*   let attatype = this.getNewWarehouseIdList.filter(item=>{ return item.value == val })[0] || {}
            console.log(attatype)
            if(attatype.attach.item.warehouseType==2||!val){
                this.showInTime = false;
            } else {
                this.showInTime = true;
            } */
        },
        async submit() {
            let form = await this.$refs['form'].validate(), other = await this.$refs['other'].validate();
            if (form && other) return { ...this.formData, extraData: JSON.stringify(this.address),estimateInboundAt: this.handleDateFormat(this.formData.estimateInboundAt, 'yyyy-mm-dd'), orderDate: this.handleDateFormat(this.formData.orderDate, 'yyyy-mm-dd') };
            return false;
        }
    },

}
</script>

